var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "verification"
  }, [_vm.status === 'loading' ? _c('div', {
    staticClass: "verification__status"
  }, [_vm._v(" Pripravujeme bezpečné overenie klienta… ")]) : _vm.status === 'submitted' ? _c('div', {
    staticClass: "verification__status"
  }, [_vm._v(" Overenie bolo odoslané a spracúva sa. ")]) : _vm.status === 'completed' ? _c('div', {
    staticClass: "verification__result verification__result--success"
  }, [_c('strong', [_vm._v("Overenie je dokončené")]), _c('span', [_vm._v("Výsledok, údaje a fotografie dokladu sa ukladajú ku klientovi.")]), _c('button', {
    attrs: {
      "type": "button"
    },
    on: {
      "click": function click($event) {
        return _vm.$emit('completed');
      }
    }
  }, [_vm._v("Zavrieť")])]) : _vm.status === 'error' ? _c('div', {
    staticClass: "verification__result verification__result--error"
  }, [_c('strong', [_vm._v("Overenie sa nepodarilo spustiť")]), _c('span', [_vm._v(_vm._s(_vm.errorMessage))]), _c('button', {
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.launch
    }
  }, [_vm._v("Skúsiť znova")])]) : _vm._e(), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.status !== 'completed' && _vm.status !== 'error',
      expression: "status !== 'completed' && status !== 'error'"
    }],
    attrs: {
      "id": "sumsub-websdk-container"
    }
  })]);

}
var staticRenderFns = []

export { render, staticRenderFns }